// 2026-05-30 Global error bus.
// Use errorBus.push({...}) from anywhere; <GlobalErrorBanner/> mounted in
// AppLayout renders all active fatal errors as a sticky red bar at the top
// of the page. Persistent — user explicitly dismisses. De-duped by source+title.
import { useEffect, useState } from 'react';
let errors = [];
const listeners = new Set();
const notify = () => listeners.forEach((l) => l());
function keyOf(e) {
    return e.dedupeKey ?? `${e.source}::${e.title}`;
}
export const errorBus = {
    push(e) {
        const k = keyOf(e);
        // Replace existing entry with same key (refresh timestamp) instead of
        // accumulating duplicates.
        errors = errors.filter((x) => keyOf(x) !== k);
        const id = Date.now() + Math.random();
        errors = [...errors, { id, ts: Date.now(), ...e }];
        notify();
        return id;
    },
    dismiss(id) {
        errors = errors.filter((e) => e.id !== id);
        notify();
    },
    dismissBySource(source) {
        errors = errors.filter((e) => e.source !== source);
        notify();
    },
    dismissByKey(key) {
        errors = errors.filter((e) => keyOf(e) !== key);
        notify();
    },
    clear() {
        errors = [];
        notify();
    },
};
export function useErrorBus() {
    const [, force] = useState(0);
    useEffect(() => {
        const l = () => force((n) => n + 1);
        listeners.add(l);
        return () => { listeners.delete(l); };
    }, []);
    return errors;
}
